import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgMapDistanceMatrixService} from 'exc-map-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {EnumerationService} from '../../services/enumeration.service';
import {IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ApplicationService} from '../../services/application.service';
import {ExgDataListComponent, ExgOverlayService} from 'exc-controls-v2';

@Component({
  selector: 'app-disposition-map2',
  templateUrl: './disposition-map2.component.html',
  styles: [],
})
export class DispositionMap2Component
  extends ExcTranslation
  implements OnInit, IExgEvent
{
  @ViewChild('DLlist', { read: ExgDataListComponent })
  VCDLlist!: ExgDataListComponent;

  @Input()
  assignList: any;

  @Input()
  multiRoute = false;

  @Input()
  set oeList(value: any[]) {
    this._oeList = value;
    this.updateMarkers();
  }
  get oeList(): any[] {
    return this._oeList;
  }

  @Input()
  set dispoDefinition(value: any) {
    this.loadDispoListDefinitions(value);
    this.updateMarkers();
  }

  @Input()
  set taskObject(value: any) {
    if (value.length > 0) {
      for (const valueElement of value) {
        this.oeObject.selected = {};
        this._taskObject = valueElement;
        this.updateMarkers();

        if (!valueElement) {
          return;
        }

        const origins: { source: any; value: string; results: any[] }[] = [];
        const adrSource: any = valueElement;
        origins.push({
          source: adrSource as any,
          value:
            adrSource?.adrStr +
            ' ' +
            adrSource?.adrHNum +
            ' ' +
            adrSource?.adrPlz +
            ' ' +
            adrSource?.adrOrt,
          results: [],
        });

        if (!this.multiRoute) {
          this.bigMap.latitude = valueElement?.adrLat || 50;
          this.bigMap.longitude = valueElement?.adrLng || 9;

          this.calcMatrixDistinations(origins);
        }
      }
    }
  }
  get taskObject(): any {
    return this._taskObject;
  }

  Events = new ExgApplicationEventEmitter();
  doDistanceMatrix = true;
  matrixRunning = false;
  DispoListDefinitions: any | undefined = undefined;

  @Output()
  OnSettingsChanged = new EventEmitter<void>();
  markerIcon: any = {};
  markerInfo: any[] = [];
  miniMap: any = {
    latitude: 50,
    longitude: 9,
    zoom: 5,
    minZoom: 1,
    maxZoom: 5,
    rectangle: {
      north: 0,
      south: 0,
      east: 0,
      west: 0,
    },
    click: (e: google.maps.MapMouseEvent | google.maps.IconMouseEvent) => {
      this.bigMap.latitude = e.latLng?.lat() || this.bigMap.latitude;
      this.bigMap.longitude = e.latLng?.lng() || this.bigMap.longitude;
    },
  };
  bigMap: any = {
    latitude: 50,
    longitude: 9,
    zoom: 8,
    minzoom: 6,
    boundsChange: (e: google.maps.LatLngBounds) => {
      this.miniMap.rectangle.north = e.getNorthEast().lat();
      this.miniMap.rectangle.east = e.getNorthEast().lng();
      this.miniMap.rectangle.south = e.getSouthWest().lat();
      this.miniMap.rectangle.west = e.getSouthWest().lng();
      this.miniMap.latitude = e.getCenter().lat();
      this.miniMap.longitude = e.getCenter().lng();
      this.miniMap.zoom = this.bigMap.zoom - 3; // (this.bigMap.zoom - 3 < this.miniMap.zoom) ? this.bigMap.zoom - 3 : this.miniMap.zoom;
    },
    ready: (e: any) => {
      const labelOriginHole = new google.maps.Point(16, 16);

      this.markerIcon.DLassignedTask = {
        url: './assets/images/disposition/mapPins/pin_home_4.svg',
        scaledSize: new google.maps.Size(32, 40),
      };
      this.markerIcon.SO = {
        url: './assets/images/disposition/house/Small_SVG_house_icon.svg',
        scaledSize: new google.maps.Size(50, 50),
      };
      this.markerIcon.DLabsence = {
        url: './assets/images/disposition/worker/pin_worker_yellow.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
      this.markerIcon.DLcapacity = {
        url: './assets/images/disposition/worker/pin_worker_orange.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
      this.markerIcon.DLunqualified = {
        url: './assets/images/disposition/worker/pin_worker_red.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
      this.markerIcon.DLneutral = {
        url: './assets/images/disposition/worker/pin_worker_default.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
      this.markerIcon.DLselected = {
        url: './assets/images/disposition/worker/pin_worker_green.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
      this.markerIcon.DLbackup = {
        url: './assets/images/disposition/worker/pin_worker_gray.svg',
        scaledSize: new google.maps.Size(32, 40),
        anchor: new google.maps.Point(16, 16),
        labelOrigin: labelOriginHole,
      };
    },
  };
  oeObject = {
    showList: false,
    isLoading: true,
    searchValue: '',
    data: [] as any[],
    selected: {} as any,
    state: 1,
    MetaInfo: {
      dataPaging: { pageNo: 0, pageSize: 25 } as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    uiFilterEnumGroup: [
      { enmName: 'starValue', enmField: 'starValue', enmTable: 'marker' },
    ],
    uiFilterSearchFields: [
      { tableField: 'adrPlz', table: 'Adresse', groupCaption: 'Schadenort' },
      { tableField: 'adrOrt', table: 'Adresse', groupCaption: 'Schadenort' },
      { tableField: 'adrStr', table: 'Adresse', groupCaption: 'Schadenort' },
    ],
    uiSortFieldGroup: [
      {
        fieldGroup: 'Karte',
        fieldTable: 'marker',
        fieldName: 'origins[0]?.result?.distanceValue',
        uiName: this.getRessource('distanceValue'),
      },
      {
        fieldGroup: 'Karte',
        fieldTable: 'marker',
        fieldName: 'origins[0]?.result?.result.duration',
        uiName: this.getRessource('duration'),
      },
      { fieldGroup: 'Schadenort', fieldTable: 'Adresse', fieldName: 'adrPlz' },
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => filters.uiValue)
        .filter(
          (filters: any) =>
            !filterType || (filterType && filterType === filters.filterType)
        );
    },
    rowChange: (index: number): void => {
      if (this.oeObject.selected !== this.getoeList()[index]) {
        this.oeObject.selected = this.getoeList()[index];
      } else {
        this.oeObject.selected = {};
        this.VCDLlist.selectedRow = -1;
      }
      console.log(this.oeObject.selected);
    },
  };

  private _oeList = [] as any[];
  private _taskObject: any;

  constructor(
    private distanceMatrixService: ExgMapDistanceMatrixService,
    public enumSvc: EnumerationService,
    private appSvc: ApplicationService,
    private overlayService: ExgOverlayService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initEnumerations();
  }

  initEnumerations(): void {
    this.oeObject.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.oeObject.uiFilterEnumGroup,
      this.oeObject.uiFilterSearchFields
    );
    this.oeObject.uiSort = this.appSvc.metaInfo.dataSort(
      this.oeObject.uiSortFieldGroup
    );
    for (const value of [-3, -2, -1, 0, 1, 2]) {
      const obj = {
        filterType: 1,
        filterGroup: 'Bewertungen',
        filterField: 'starValue',
        filterIdent: value,
        uiCaption: 'Sterne: ' + (value >= -2 ? value + 3 : 'Keine Bewertung'),
        filterCondition: { operator: '=', value },
        uiName: 'Sterne_' + value,
        uiValue: false,
      };
      this.oeObject.uiFilter.push(obj);
    }
  }

  // Map
  getOeListMap(): any[] {
    if (!this.oeList) {
      return [];
    }
    return this.oeList
      .filter(
        // Visible
        (oe) => oe.visible
      )
      .filter(
        // Selected Oe
        (oe) =>
          (this.oeObject.selected?.oeID &&
            oe.adrLat === this.oeObject.selected.adrLat &&
            oe.adrLng === this.oeObject.selected.adrLng) ||
          !this.oeObject.selected?.oeID
      );
  }

  calcMatrixDistinations(
    origins: { source: any; value: string; results: any[] }[]
  ): void {
    const matrixDestinations: { source: any; value: string; results: any[] }[] =
      [];

    for (const markerElement of this.markerInfo.filter(
      (marker: any) => marker.visible
    )) {
      matrixDestinations.push({
        source: markerElement.oeData,
        value: `${markerElement.oeData.adrStr} ${markerElement.oeData.adrHNum} ${markerElement.oeData.adrPlz} ${markerElement.oeData.adrOrt}`,
        results: [],
      });
    }

    if (!this.matrixRunning) {
      this.getDistanceMatrix(origins, matrixDestinations).then((a: any) => {
        this.matrixRunning = false;
        for (const elem of origins) {
          elem.source.destinations = elem.results;
        }
        for (const elem of matrixDestinations) {
          elem.source.origins = elem.results;
        }
      });
    }
  }

  getDistanceMatrix(origins: any[], destinations: any[]): Promise<any> {
    if (!this.doDistanceMatrix) {
      return new Promise(async (res, rej) => {
        res({ origins, destinations });
      });
    }
    return new Promise(async (res, rej) => {
      const originChunks: any[] = [];
      const destinationChunks: any[] = [];
      for (let i = 0; i < origins.length; i = i + 10) {
        originChunks.push(origins.slice(i, i + 10));
      }
      for (let i = 0; i < destinations.length; i = i + 10) {
        destinationChunks.push(destinations.slice(i, i + 10));
      }
      // tslint:disable-next-line:prefer-for-of
      for (let o = 0; o < originChunks.length; o++) {
        // tslint:disable-next-line:prefer-for-of
        for (let p = 0; p < destinationChunks.length; p++) {
          const start = Date.now();
          const abc = await this.getDistanceMatrixSub(
            originChunks[o],
            destinationChunks[p]
          ).catch((err) => {
            console.log(err);
          });
          if (origins.length * destinations.length > 100) {
            console.log(1100 - (Date.now() - start));
            await new Promise((r) =>
              setTimeout(r, 1100 - (Date.now() - start))
            );
          }
        }
      }
      res({ origins, destinations });
    });
  }

  getDistanceMatrixSub(
    origins: any[],
    destinations: any[],
    retries: number = 0
  ): Promise<any> {
    return new Promise((res, rej) => {
      // let service = new google.maps.DistanceMatrixService();
      const originChunksValueArray: string[] = origins.map((a) => a.value);
      const destinationChunksValueArray: string[] = destinations.map(
        (a) => a.value
      );
      this.distanceMatrixService
        .getDistanceMatrix({
          origins: originChunksValueArray,
          destinations: destinationChunksValueArray,
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .subscribe(
          (response: any) => {
            const originList = response.originAddresses;
            const destinationList = response.destinationAddresses;

            for (let i = 0; i < origins.length; i++) {
              const results = response.rows[i].elements;
              for (let j = 0; j < results.length; j++) {
                try {
                  const element = results[j];
                  const distance = element.distance.text;
                  const distanceValue = element.distance.value;
                  const duration = element.duration.text;
                  const durationValue = element.duration.value;
                  const from = originList[i];
                  const to = destinationList[j];
                  // origins[i].results.push({
                  //   source: destinations[j].source,
                  //   result: {distance, distanceValue, duration, durationValue, from, to}
                  // });
                  destinations[j].results.push({
                    source: undefined, // origins[i].source,
                    result: {
                      distance,
                      distanceValue,
                      duration,
                      durationValue,
                      from,
                      to,
                    },
                  });
                } catch {
                  // origins[i].results.push({
                  //   source: destinations[j].source,
                  //   result: {distance: 'NaN', duration: 'NaN', from: 'not found', to: 'not found'}
                  // });
                  destinations[j].results.push({
                    source: undefined, // origins[i].source,
                    result: {
                      distance: 'NaN',
                      duration: 'NaN',
                      from: 'not found',
                      to: 'not found',
                    },
                  });
                }
                res({ origins, destinations });
              }
            }
          },
          (error: any) => {
            if (retries < 3) {
              retries++;
              const prom = new Promise<any>(async (e: any) => {
                setTimeout(async () => {
                  return await this.getDistanceMatrixSub(
                    origins,
                    destinations,
                    retries
                  );
                }, 1000 * retries);
              }).then((x) => {
                return x;
              });
              return prom;
            } else {
              return new Promise<any>((e) => {});
            }
          }
        );
    });
  }

  getMarker = (type: string, marker?: any): any => {
    const test = this.applyDispositionListDefinition(marker);
    // let test = {visible: true, mode: 'neutral', messages: []};
    // const existingMarkerInfo = this.markerInfo[this.markerInfo.indexOf(marker)];
    marker.messages = test.messages;
    marker.visible = test.visible;
    return {
      marker: this.markerIcon[type + test.mode],
      visible: test.visible,
      messages: test.messages,
      isOpen: false,
    };
  }

  updateMarkers(): void {
    this.markerInfo = [];
    if (this._oeList && this._oeList.length > 0) {
      for (const oeItem of this._oeList) {
        const marker = this.getMarker('DL', oeItem);
        Object.assign(oeItem, { marker });
        Object.assign(marker, { oeData: oeItem });
        this.markerInfo.push(marker);
      }
    }
  }

  loadDispoListDefinitions(DBResult: any): void {
    if (DBResult && !this.DispoListDefinitions) {
      this.DispoListDefinitions = {} as any;
      for (const row of DBResult) {
        this.DispoListDefinitions[row.ldefListDefinitionType] = {} as any;
        for (const typeRow of row.Types) {
          this.DispoListDefinitions[row.ldefListDefinitionType][
            typeRow.ldefFieldName
          ] = {
            ldefEntity: typeRow.ldefEntity,
            ldefExclude: typeRow.ldefExclude,
            Values: typeRow.Values,
          } as any;
          for (const valueRow of typeRow.Values) {
            valueRow.lvalValue = JSON.parse(valueRow.lvalValue);
          }
        }
      }
    }
  }

  applyDispositionListDefinition(marker: any): {
    visible: boolean;
    mode: string;
    messages: any[];
  } {
    const rtVal = { visible: true, mode: 'neutral', messages: [] as any[] };

    Object.assign(marker, { absence: [], route: [] });

    if (this.DispoListDefinitions) {
      for (const [k, v] of Object.entries(this.DispoListDefinitions)) {
        for (const [kItem, vItem] of Object.entries(v as any)) {
          if (k === 'BLACKLIST' || k === 'WHITELIST') {
            if (this.taskObject) {
              // for (const taskObject of this.taskObject) {
              const index = (vItem as any).Values.findIndex((e: any) => {
                const matchOE =
                  e.lval_FK.toUpperCase() === marker.oeID.toUpperCase();
                if (matchOE) {
                  return (
                    e.lvalValue.findIndex((o: any) => {
                      return (
                        this.taskObject[kItem].toString().toUpperCase() ===
                        o.toUpperCase()
                      );
                    }) > -1
                  );
                }
                return false;
              });

              if (
                (k === 'BLACKLIST' && index > -1) ||
                (k === 'WHITELIST' && index === -1)
              ) {
                const message = ExcCoreModule.String.Format(
                  '{0}: {1}',
                  k,
                  this.enumSvc.getFieldCaption((vItem as any).ldefEntity, kItem)
                );
                rtVal.visible = rtVal.visible && !(vItem as any).ldefExclude;
                rtVal.mode = 'unqualified';
                if (!rtVal.messages.includes(message)) {
                  rtVal.messages.push(message);
                  marker.messages.push(message);
                }
              }
              // }
            } else {
              rtVal.visible = true;
              rtVal.mode = 'neutral';
              // ToDo: Typ der message
              rtVal.messages = [];
            }
          }
          if (k === 'ABSENCE') {
            let dateFrom = '';
            let dateTo = '';
            let deputy = '';
            const index = (vItem as any).Values.findIndex((e: any) => {
              const matchOE =
                e.lval_FK.toUpperCase() === marker.oeID.toUpperCase();
              if (matchOE) {
                return (
                  e.lvalValue.findIndex((o: any) => {
                    const dFrom = new Date(o.from as string);
                    const dTo = new Date(o.to as string);
                    const dNoDispoFrom =
                      new Date(o.noDispoFrom as string) ||
                      new Date(o.from as string);
                    const dNoDispoTo =
                      new Date(o.noDispoTo as string) ||
                      new Date(o.to as string);
                    dateFrom = dNoDispoFrom.toLocaleDateString();
                    dateTo = dNoDispoTo.toLocaleDateString();
                    deputy = o.deputy;

                    if (new Date() < dTo) {
                      marker.absence.push({
                        dNoDispoFrom,
                        dNoDispoTo,
                        dFrom,
                        dTo,
                        deputy,
                      });

                      const message = ExcCoreModule.String.Format(
                        '{0}: von {1} bis {2}',
                        'Abwesenheit',
                        dateFrom,
                        dateTo,
                        deputy.length > 0
                          ? ' | Vertretung: ' + deputy
                          : '(Keine Vertretung)'
                      );
                      rtVal.messages.push(message);
                      marker.messages.push(message);
                    }

                    return new Date() > dNoDispoFrom && new Date() < dNoDispoTo;
                  }) > -1
                );
              }
              return false;
            });
            if (index > -1) {
              rtVal.mode = 'absence';
              rtVal.visible = rtVal.visible && !(vItem as any).ldefExclude;
            }
          }
          if (k === 'CAPACITY') {
            const index = (vItem as any).Values.findIndex((e: any) => {
              const matchOE =
                e.lval_FK.toUpperCase() === marker.oeID.toUpperCase();
              if (matchOE) {
                let val = e.lvalValue.usr as number;

                if (
                  (e.lvalValue.adm as number) !== 0 &&
                  (e.lvalValue.adm as number) < val
                ) {
                  val = e.lvalValue.adm as number;
                }

                Object.assign(marker, {
                  capValue: Number(val),
                  cap: Number(val) - marker.capCount,
                });
                const message = ExcCoreModule.String.Format(
                  'Kapazität: {1} | Aktiv: {0} (Gesamt: {2})',
                  marker.capCount,
                  marker.cap,
                  marker.capValue
                );
                rtVal.messages.push(message);
                marker.messages.push(message);

                if ((val > 0 && val < marker.capCount) || val === -1) {
                  return true;
                }
              }
              return false;
            });
            if (index > -1) {
              rtVal.visible = rtVal.visible && !(vItem as any).ldefExclude;
              rtVal.mode = 'capacity';
            }
          }
          if (k === 'BACKUP') {
            const index = (vItem as any).Values.findIndex((e: any) =>
              e.lval_FK.toUpperCase() === marker.oeID.toUpperCase() && e.lvalValue === true
            );
            if (index > -1 && rtVal.mode === 'neutral') {
              rtVal.mode = 'backup';
            }
          }
          if (k === 'ROUTE') {
            const today = new Date();
            let dateFrom: Date;
            let dateTo: Date;
            let locations = [] as any[];
            const index = (vItem as any).Values.findIndex((e: any) => {
              const matchOE =
                e.lval_FK.toUpperCase() === marker.oeID.toUpperCase();
              if (matchOE) {
                let elementIndex = 1;
                for (const lvalElement of e.lvalValue) {
                  dateFrom = new Date(lvalElement.from as string);
                  dateTo = new Date(lvalElement.to as string);
                  locations = lvalElement.locations;

                  // DateTo > Heute
                  if (dateTo && today < dateTo) {
                    // To calculate the time difference of two dates
                    // To calculate the no. of days between two dates
                    const DateFromDifferenceInDays =
                      (today.getTime() - dateFrom.getTime()) /
                      (1000 * 3600 * 24);

                    // DateFrom < Heute | DateFrom in 7 Tagen
                    if (
                      dateFrom &&
                      (!(DateFromDifferenceInDays < -7) || dateFrom < today)
                    ) {
                      let message = elementIndex.toString() + '. Tour: ';
                      elementIndex = elementIndex + 1;
                      marker.route.push({ dateFrom, dateTo, locations });

                      for (const location of locations) {
                        const LocDateFrom = new Date(location.from as string);
                        const dFrom = LocDateFrom.toLocaleDateString().replace(
                          LocDateFrom.getFullYear().toString(),
                          ''
                        );
                        const LocDateTo = new Date(location.to as string);
                        const dTo = LocDateTo.toLocaleDateString().replace(
                          LocDateTo.getFullYear().toString(),
                          ''
                        );
                        message += ExcCoreModule.String.Format(
                          '{3} ({0}{1}{2})[{4}]',
                          dFrom,
                          dFrom !== dTo ? '-' : '',
                          dFrom !== dTo ? dTo : '',
                          location.postCode,
                          location.capacity
                        );
                        message += ';  ';
                      }
                      rtVal.messages.push(message);
                      marker.messages.push(message);
                    }
                  }
                }
              }
              return false;
            });
          }
        }
      }
    }
    if (
      this.taskObject &&
      this.taskObject.marker &&
      this.taskObject.marker === marker
    ) {
      rtVal.mode = 'selected';
    }
    return rtVal;
  }

  assign(marker: any): void {
    if (this.taskObject) {
      if (this.taskObject.marker) {
        const mark = this.taskObject.marker;
        this.taskObject.marker = undefined;
        const originalIndex2 = this.oeList.findIndex((e) => e === mark);
        this.markerInfo[originalIndex2] = this.getMarker('DL', mark);
      }
      this.taskObject.marker = this.getoeList()[marker];
      const originalIndex = this.oeList.findIndex(
        (e) => e === this.taskObject.marker
      );
      this.markerInfo[originalIndex] = this.getMarker(
        'DL',
        this.taskObject.marker
      );
      this.prepDispoU();
    }
  }

  assignFromMap(marker: any): void {
    if (this.taskObject) {
      if (this.taskObject.marker) {
        const mark = this.taskObject.marker;
        this.taskObject.marker = undefined;
        const originalIndex2 = this.oeList.findIndex((e) => e === mark);
        this.markerInfo[originalIndex2] = this.getMarker('DL', mark);
      }
      this.taskObject.marker = marker;
      const originalIndex = this.oeList.findIndex(
        (e) => e === this.taskObject.marker
      );
      this.markerInfo[originalIndex] = this.getMarker(
        'DL',
        this.taskObject.marker
      );
      this.prepDispoU();
    }
  }

  // DL-Table
  Search(searchValue: string): void {
    this.oeObject.searchValue = searchValue;
  }

  getoeList(): any[] {
    if (!this.oeList) {
      return [];
    }
    // console.log(this.oeList.filter(oeObject => oeObject.absence));
    return this.oeList
      .filter(
        // Visible
        (oe) => oe.visible
      )
      .filter(
        // Suchtext in den OEs
        (oe) =>
          this.oeObject.searchValue === '' ||
          (oe &&
            JSON.stringify({
              adrHNum: oe.adrHNum,
              adrLkz: oe.adrHNum,
              adrOrt: oe.adrOrt,
              adrPlz: oe.adrPlz,
              adrStr: oe.adrStr,
              adrZusatz: oe.adrZusatz,
              capCount: oe.capCount,
              messages: oe.messages,
              oeEName: oe.oeEName,
              oeID: oe.oeID,
              oeName: oe.oeName,
              starValue: oe.starValue,
            })
              .toLowerCase()
              .includes(this.oeObject.searchValue.toLowerCase()))
      )
      .filter(
        // Filter Typ 1
        (oe) =>
          this.oeObject.uiFilterAktiv(1).length === 0 ||
          this.oeObject
            .uiFilterAktiv(1)
            .find((excFilter: any) =>
              excFilter.filterIdent >= -2
                ? excFilter.filterIdent === oe.starValue
                : oe.starValue === null
            )
      )
      .filter(
        // Filter Typ 2
        (oe) =>
          this.oeObject.uiFilterAktiv(2).length === 0 ||
          this.oeObject
            .uiFilterAktiv(2)
            .find(
              (excFilter: any) =>
                excFilter.filterCondition.value === '' ||
                (!excFilter.filterCondition.value.includes('%') &&
                  oe[excFilter.filterField]
                    .toLowerCase()
                    .includes(
                      excFilter.filterCondition.value.trim().toLowerCase()
                    )) ||
                (excFilter.filterCondition.value.includes('%') &&
                  ((excFilter.filterCondition.value.trim().startsWith('%') &&
                    oe[excFilter.filterField]
                      .toLowerCase()
                      .endsWith(
                        excFilter.filterCondition.value
                          .trim()
                          .replace('%', '')
                          .toLowerCase()
                      )) ||
                    (excFilter.filterCondition.value.trim().endsWith('%') &&
                      oe[excFilter.filterField]
                        .toLowerCase()
                        .startsWith(
                          excFilter.filterCondition.value
                            .trim()
                            .replace('%', '')
                            .toLowerCase()
                        )) ||
                    (excFilter.filterCondition.value.trim().startsWith('%') &&
                      excFilter.filterCondition.value.trim().endsWith('%') &&
                      oe[excFilter.filterField]
                        .toLowerCase()
                        .includes(
                          excFilter.filterCondition.value
                            .trim()
                            .replace('%', '')
                            .toLowerCase()
                        ))))
            )
      )
      .sort(
        // Default Sort
        (a, b) => {
          return a.origins && b.origins
            ? a.origins[0]?.result?.distanceValue >
              b.origins[0]?.result?.distanceValue
              ? 1
              : -1
            : a.oeName > b.oeName
            ? 1
            : -1;
        }
      )
      .sort(
        // Sortelement of Sortmenue
        (a, b) => {
          if (this.oeObject.uiSortAktiv().length > 0) {
            for (const sortElement of this.oeObject.uiSortAktiv()) {
              return sortElement.uiValue === 1
                ? a[sortElement.sortField] < b[sortElement.sortField]
                  ? 1
                  : -1
                : b[sortElement.sortField] < a[sortElement.sortField]
                ? -1
                : 1;
            }
          }
          return a.oeName > b.oeName ? 1 : -1;
        }
      );
  }

  // Fill People to the call array
  prepDispoU(): void {
    if (this.taskObject && this.taskObject.marker && this.taskObject.vorgCKD) {
      ExcCoreModule.Array.Add(this.assignList.data, {
        vorgID: this.taskObject.vorgID,
        oeID: this.taskObject.marker.oeID,
        vorgUPT: this.taskObject.vorgUPT,
      });
    }
    this.updateMarkers();
  }

  showSettings(data: any): void {
    this.overlayService
      .show('SvUserProfileComponent', data, true)
      .subscribe(() => {
        this.DispoListDefinitions = undefined;
        this.OnSettingsChanged.emit();
      });
  }
}
